import { Button } from '@meitu/saas-ui';
import { Editor } from '@meitu/saas-editor-core';

const RenderStage: React.FC<{ stageIndex: number; scale: number; editor: Editor; componentId: string }> = ({
    stageIndex,
    scale,
    editor,
    componentId,
}) => {
    return (
        <div className="render-stage">
            <Button
                style={{
                    transform: `scale(${1 / scale}) translate(-50%, 50%)`,
                    backgroundColor: '#3388ffc2',
                }}
                type="primary"
                onClick={() => {
                    window.open(
                        `${window.location.origin}${window.location.pathname}?mode=internal_designer&id=${
                            componentId
                        }&isUpdateAIPPTComponent=1`,
                        '_blank',
                    );
                }}
            >
                查看组件
            </Button>
            <>{editor.preview.getNavigatorNode(stageIndex)}</>
        </div>
    );
};

export default RenderStage;
